import { render, staticRenderFns } from "./userMsg.vue?vue&type=template&id=116a3422&scoped=true&"
import script from "./userMsg.vue?vue&type=script&lang=js&"
export * from "./userMsg.vue?vue&type=script&lang=js&"
import style0 from "./userMsg.vue?vue&type=style&index=0&id=116a3422&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a3422",
  null
  
)

export default component.exports